import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest, IAddCreatorsToFitRequestPayload } from "../types";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useAddCreatorToFitRequest(onSuccess?: (data: BackednResponse<IAIWorkspaceRequest>) => void) {
  const addCreatorToFitRequest = useCallback(
    (payload: IAddCreatorsToFitRequestPayload) =>
      AiWorkspaceService.addCreatorsToFitRequest(payload)
        .then((res) => {
          ToastService.success("Creator added successfully");
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to add creator";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          ToastService.error(errorMessage);
          throw err;
        }),
    []
  );

  const {
    mutate: addCreator,
    isLoading: isAddingCreator,
    isSuccess: isCreatorAdded,
  } = useMutation<IAddCreatorsToFitRequestPayload, BackednResponse<IAIWorkspaceRequest>>({
    mutationFn: addCreatorToFitRequest,
    options: QUERY_OPTIONS,
    onSuccess: (c, data) => {
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS]});
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUEST]});
      onSuccess?.(data);
    },
  });

  return { addCreator, isAddingCreator, isCreatorAdded };
}
